{
    "ReportIntervalLanguageFifteenMinutes": "15 minutos",
    "ReportIntervalLanguageThirtyMinutes": "30 minutos",
    "ReportIntervalLanguageOneHour": "1 hora",
    "ReportIntervalLanguageTwoHour": "2 horas",
    "ReportIntervalLanguageTypeMinute": "Minutos",
    "ReportIntervalLanguageTypeHour": "Hora",
    "ReportIntervalLanguageTypeHourPluralised": "Horas",
    "ReportIntervalLanguageInterpolated": "Total de chamadas por {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Chamadas por {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Chamadas por {}",
    "ReportIntervalTypeMinutes": "Minutos",
    "ReportIntervalTypeHours": "Horas",
    "ReportIntervalTypeDay": "Dia",
    "ReportIntervalTypeWeek": "Semana",
    "ReportIntervalTypeMonth": "Mês",
    "NAME": "ReportIntervalLanguage",
    "ReportIntervalEntityLanguageCallByNoValueInterpolated": "Chamadas por {} ({})",
    "ReportIntervalEntityLanguageCallByInterpolated": "Chamadas por {} {} ({})",
    "ReportIntervalTypeDayOfTheWeek": "Dia da semana",
    "ReportIntervalEntityTypeDevicesExtensionsAA": "Dispositivos (Extensões\/IVR)",
    "ReportIntervalEntityTypeAgents": "Agentes",
    "ReportIntervalEntityTypeGroups": "Grupos\/Filas",
    "ReportIntervalEntityTypeDNIS": "DNIS"
}